export const TOGGLE_VIEW = {
  CORE_UNITS: 'CORE_UNITS',
  INTERVENTIONS: 'INTERVENTIONS',
  LAUNCH: 'LAUNCH',
  MONITOR: 'MONITOR',
  PREPARE: 'PREPARE',
  SETUP: 'SETUP',
  SPECIALIZED_UNITS: 'SPECIALIZED_UNITS',
}

/** K8 lesson-progress views (legacy MONITOR kept for persisted session). */
export const isK8ProgressToggleView = toggleView =>
  toggleView === TOGGLE_VIEW.CORE_UNITS ||
  toggleView === TOGGLE_VIEW.SPECIALIZED_UNITS ||
  toggleView === TOGGLE_VIEW.MONITOR
